import PasswordStatusIndicator from "./PasswordStatusIndicator";

export default PasswordStatusIndicator;
